/*
 * biobio-bundle-details.js — V2 accordion + INCI toggle
 *
 * Custom element <bundle-details>. Dois comportamentos:
 *   1. Accordion por card: clique no head expande/colapsa o body do componente.
 *      Default: tudo collapsed. Pattern Sallve no mobile.
 *   2. Toggle INCI: clique no botão "ver detalhes dos ingredientes" expande
 *      a composição completa dentro do card já aberto.
 */

class BundleDetails extends HTMLElement {
  constructor() {
    super();
    this._onClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }

  handleClick(event) {
    const accordionToggle = event.target.closest('[data-accordion-toggle]');
    if (accordionToggle && this.contains(accordionToggle)) {
      event.preventDefault();
      this.toggleAccordion(accordionToggle);
      return;
    }

    const inciToggle = event.target.closest('[data-inci-toggle]');
    if (inciToggle && this.contains(inciToggle)) {
      event.preventDefault();
      this.toggleInci(inciToggle);
    }
  }

  toggleAccordion(button) {
    const article = button.closest('.bundle-details__item');
    if (!article) return;
    const body = article.querySelector('.bundle-details__item-body');
    if (!body) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      button.setAttribute('aria-expanded', 'false');
      body.setAttribute('hidden', '');
    } else {
      button.setAttribute('aria-expanded', 'true');
      body.removeAttribute('hidden');
    }
  }

  toggleInci(button) {
    const container = button.closest('[data-inci]');
    if (!container) return;

    const content = container.querySelector('[data-inci-content]');
    const showLabel = button.querySelector('[data-inci-toggle-show]');
    const hideLabel = button.querySelector('[data-inci-toggle-hide]');
    if (!content || !showLabel || !hideLabel) return;

    const isOpen = !content.hasAttribute('hidden');
    if (isOpen) {
      content.setAttribute('hidden', '');
      button.setAttribute('aria-expanded', 'false');
      showLabel.removeAttribute('hidden');
      hideLabel.setAttribute('hidden', '');
    } else {
      content.removeAttribute('hidden');
      button.setAttribute('aria-expanded', 'true');
      showLabel.setAttribute('hidden', '');
      hideLabel.removeAttribute('hidden');
    }
  }
}

if (!customElements.get('bundle-details')) {
  customElements.define('bundle-details', BundleDetails);
}
